<template>
    <div class="row">
        <div class="col-md-12">
            <label v-if="title && title.trim().length > 0">
                {{ title }} <span class="text-danger">{{ isRequire ? '(*)' : '' }}</span>
            </label>
        </div>
        <div class="col-md-12">
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" :id="idInput" :placeholder="placeholder"
                    :disabled="isReadOnly" v-model="localValue" @change="updateValue">
                    <label class="custom-control-label" :for="idInput"></label>
            </div>
        </div>
    </div>
        
        <div class="text-danger text-right mb-2" v-if="error">
            {{ error }}
        </div>
</template>

<script>
import $ from 'jquery';
import { ref, toRefs } from "vue";
export default {
    name: "TheSwitchButton",
    props: {
        title: String,
        placeholder: String,
        error: String,
        isReadOnly: Boolean,
        isRequire: Boolean,
        initialValue: {
            type: [Number, Boolean, String],
            default: false,
            validator: value => ['0', '1', 'true', 'false', 0, 1, true, false].includes(value)
        }
    },
    setup(props) {
    },

    data() {
        return {
            idInput: 'checkbox_' + Math.random().toString(36).substr(2, 9),
            localValue: this.parseBoolean(this.initialValue)
        }
    },
    methods: {

        parseBoolean(value) {
        if (typeof value === 'string') {
            return value.toLowerCase() === 'true';
        }
        return Boolean(value);
        },
        updateValue(event) {
            this.localValue = event.target.checked;
            this.$emit('update:initialValue', this.localValue);
        }
    },
    watch: {
        initialValue(newValue) {
            this.localValue = this.parseBoolean(newValue);
    },
        error() {
            if(this.error) {
                $(this.$refs.select).addClass('is-invalid');
            } else {
                $(this.$refs.select).removeClass('is-invalid');
            }
        }
    },
    mounted() {
        let self = this;
        this.$emit('update:initialValue', this.localValue);
    }
}
</script>
<style>
</style>